import React, { Component } from 'react';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';
import { STabs } from '@avalara/skylab-sdk/react';

const log = new Logger('TABS', LOG_LEVELS.DEBUG);

export class TabsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.onTabChange = this.onTabChange.bind(this);
    this.state = {activeTab: 0};
  }

  onTabChange(event) {
    const selectedTabIndex = event.detail.index;
    if (this.state.activeTab === selectedTabIndex) {
      return;
    }
    this.setState({activeTab: selectedTabIndex});
    if(typeof this.props.onTabChange === "function") {
      this.props.onTabChange(selectedTabIndex + 1, event, selectedTabIndex);
    }
  }

  componentDidMount() {
    const allChildren = React.Children.toArray(this.props.children);
    const validChildren = allChildren.filter(child => React.isValidElement(child) && child.type === TabsPanel);
    if (Array.isArray(validChildren) && validChildren.length > 1) {
      validChildren.forEach((child, index) => {
        if (child.props && child.props.selected === "true") {
          this.setState({ activeTab: index });
        }
      });
    }
  }

  render() {
    const allChildren = React.Children.toArray(this.props.children);
    const validChildren = allChildren
      .filter(child => React.isValidElement(child) && child.type === TabsPanel && child.props && Object.keys(child.props).length > 0);
    const tabObject = validChildren
      .map((child, index) => {
        let label;
        if (child.props?.label && child.props.label.props) {
          label = child.props.label.props.string ? child.props.label.props.string : child.props.label.props.children;
        } else {
          label = child.props.label;
        }
        
        return {
          id: `tab-${index + 1}`,
          label: label,
          tabPanelId: `tab-panel-${index + 1}`,
          selected: this.state.activeTab === index
        };
      });
    return (
      <div>
        <STabs 
          id="tabs-container"
          tabItems={tabObject}
          onS-select={this.onTabChange}
        />
        {validChildren.length > 1 ? (
          validChildren.map((child, index) => {
            const tabNumber = index + 1;
            return (
              <div 
                key={`tab-panel-${tabNumber}`} 
                id={`tab-panel-${tabNumber}`} 
                role="tabpanel" 
                aria-labelledby={`tab-${tabNumber}`} 
                tabIndex={index}
                style={{ display: this.state.activeTab === index ? 'block' : 'none' }}
              >
                {child.props.children}         
              </div>
            );
          })
        ): (
          <div 
            key="tab-panel-1" 
            id="tab-panel-1" 
            role="tabpanel" 
            aria-labelledby="tab-1" 
            tabIndex={0}
          >
            {validChildren[0] && validChildren[0].props && validChildren[0].props.children}
          </div> 
        )}
      </div>
    );
  }
}

export class TabsPanel extends Component {
  render() {
    return (
      <div></div>
    )
  }
}

export default (TabsContainer, TabsPanel);
